var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.166 4.9974H18.3327V6.66406H16.666V17.4974C16.666 17.7184 16.5782 17.9304 16.4219 18.0867C16.2657 18.2429 16.0537 18.3307 15.8327 18.3307H4.16602C3.945 18.3307 3.73304 18.2429 3.57676 18.0867C3.42048 17.9304 3.33268 17.7184 3.33268 17.4974V6.66406H1.66602V4.9974H5.83268V2.4974C5.83268 2.27638 5.92048 2.06442 6.07676 1.90814C6.23304 1.75186 6.445 1.66406 6.66602 1.66406H13.3327C13.5537 1.66406 13.7657 1.75186 13.9219 1.90814C14.0782 2.06442 14.166 2.27638 14.166 2.4974V4.9974ZM14.9993 6.66406H4.99935V16.6641H14.9993V6.66406ZM7.49935 9.16406H9.16602V14.1641H7.49935V9.16406ZM10.8327 9.16406H12.4993V14.1641H10.8327V9.16406ZM7.49935 3.33073V4.9974H12.4993V3.33073H7.49935Z",
    fill: "#F5222D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash_red.83709b7517657ea9e1293b02d0a5b2c3.svg";
export { ForwardRef as ReactComponent };